import React, { Suspense, useEffect, useState } from "react";
import { HorizontalTeamStatsTable } from "./components/TeamStatsTable";
import PlayerStatsTable from "./components/PlayerStatsTable";
import RefreshButton from "./components/RefreshButton";
import ProjStatsToggle from "./components/ProjStatsToggle";
import { initStaticData } from "./utils/matchupUtils";
import useMatchupStore from "./store/MatchupStore";
import { useViewport } from "../components/hooks/useViewport";

function TeamToggle({ staticData }) {
  const [selectedTeam, setSelectedTeam] = useMatchupStore((state) => [
    state.selectedTeam,
    state.setSelectedTeam,
  ]);
  function handleToggle(team) {
    setSelectedTeam(team);
  }

  return (
    <div
      className="inline-flex min-w-0 w-full md:hidden rounded-md shadow-xs mx-auto"
      role="group"
    >
      <button
        type="button"
        onPointerDown={() => handleToggle("team1")}
        className={`px-4 py-2 flex-1 text-sm font-medium border truncate ${
          selectedTeam === "team1"
            ? "bg-gray-100 text-black dark:bg-gray-700 dark:text-white sm:dark:hover:bg-gray-700"
            : "bg-white text-gray-900 bg-transparent dark:bg-gray-900 dark:text-gray-200 sm:dark:hover:bg-gray-800"
        } border-gray-300 rounded-s-lg sm:hover:bg-gray-100 hover:text-black dark:border-gray-700 dark:hover:text-white `}
      >
        {staticData.team1.teamSeason.seasonName}
      </button>
      <button
        type="button"
        onPointerDown={() => handleToggle("team2")}
        className={`-ml-px px-4 py-2 flex-1  text-sm font-medium border truncate ${
          selectedTeam === "team2"
            ? "bg-gray-100 text-black dark:bg-gray-700 dark:text-white sm:dark:hover:bg-gray-700"
            : "bg-white text-gray-900 bg-transparent dark:bg-gray-900 dark:text-gray-200 sm:dark:hover:bg-gray-800"
        } border-gray-300 rounded-e-lg sm:hover:bg-gray-100 hover:text-black dark:border-gray-700 dark:hover:text-white `}
      >
        {staticData.team2.teamSeason.seasonName}
      </button>
    </div>
  );
}

export default function MatchupView({ userId, env, staticData }) {
  const [lastRefreshed] = useMatchupStore((state) => [state.lastRefreshed]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    initStaticData(staticData);
  }, [staticData]);

  useEffect(() => {
    // Uncomment to enable auto-refresh:
    // const intervalId = setInterval(refreshMatchupData, 30000); // 30 seconds
    // return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 50);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const isWide = useViewport(768);

  const animationStyle = {
    opacity: isLoaded ? 1 : 0,
    transform: isLoaded ? "translateY(0)" : "translateY(12px)",
    transition:
      "opacity 500ms cubic-bezier(0.4, 0, 0.2, 1), transform 500ms cubic-bezier(0.4, 0, 0.2, 1)",
  };

  const formattedLastRefresh = lastRefreshed
    ? lastRefreshed
        .toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        })
        .replace(" ", "")
        .toLowerCase()
    : null;

  if (!isLoaded) {
    return null;
  }

  return (
    <>
      <Suspense
        fallback={
          <div className="flex items-center justify-center h-96">
            Matchup loading...
          </div>
        }
      >
        <div>
          {/*<MatchupHeader*/}
          {/*  team1={staticData.team1}*/}
          {/*  team2={staticData.team2}*/}
          {/*  team1Complete={6.5}*/}
          {/*  team1Progress={0.5}*/}
          {/*  team2Complete={7.0}*/}
          {/*  team2Progress={1.0}*/}
          {/*/>*/}
          <div className="-mx-4 md:-mx-2">
            <HorizontalTeamStatsTable formula={staticData.formula} />
          </div>

          <div className="sticky top-0 md:static z-20 py-2 bg-gray-50 dark:bg-gray-900 md:bg-transparent md:border-transparent -mx-4 pl-2 pr-2.5 flex items-center justify-between md:justify-end gap-2.5 border-b dark:border-gray-800">
            <TeamToggle staticData={staticData} />
            <div className="flex items-center gap-2">
              <ProjStatsToggle />
              <RefreshButton />
            </div>
          </div>

          <div className="-mx-4 md:-mx-2 -mt-px md:mt-0">
            <PlayerStatsTable staticData={staticData} />
          </div>
        </div>
      </Suspense>
    </>
  );
}
